export default __webpack_public_path__ + "static/media/check-field-icon.3e27c5bd.svg";